import { Component, inject, input, signal } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { I18nService } from '../../../../core';

@Component({
  selector: 'app-cf-inline-copy-button',
  standalone: true,
  imports: [LucideAngularModule],
  template: `
    <button
      type="button"
      class="cf-copy-btn"
      [class.cf-copy-btn--hover-only]="hoverOnly()"
      [attr.aria-label]="t('customFields.code.copyAria', undefined, 'Copiar')"
      [title]="justCopied() ? t('customFields.code.copied', undefined, 'Copiado!') : t('customFields.code.copyTooltip', undefined, 'Copiar')"
      (click)="copyToClipboard($event)"
    >
      <lucide-icon
        [name]="justCopied() ? 'check' : 'copy'"
        [size]="10"
        [strokeWidth]="2"
      ></lucide-icon>
    </button>
  `,
  styles: [
    `
      .cf-copy-btn {
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 1px solid var(--border);
        border-radius: 4px;
        background: var(--bg-surface);
        color: var(--muted);
        cursor: pointer;
        transition: background 120ms ease, color 120ms ease, opacity 120ms ease;
        padding: 0;
      }

      .cf-copy-btn:hover {
        background: color-mix(in srgb, var(--bg-surface) 84%, var(--text) 16%);
        color: var(--text);
      }

      .cf-copy-btn--hover-only {
        opacity: 0;
        pointer-events: none;
        transition: opacity 140ms ease, background 120ms ease, color 120ms ease;
      }

      :host-context(.group:hover) .cf-copy-btn--hover-only,
      :host-context(.gl-row-grid:hover) .cf-copy-btn--hover-only,
      :host-context(.card-tile:hover) .cf-copy-btn--hover-only,
      :host-context(.quick-chip:hover) .cf-copy-btn--hover-only {
        opacity: 1;
        pointer-events: auto;
      }

    `,
  ],
})
export class CfInlineCopyButtonComponent {
  private readonly i18n = inject(I18nService);
  readonly t = this.i18n.t.bind(this.i18n);

  readonly textToCopy = input.required<string>();
  readonly hoverOnly = input<boolean>(false);
  readonly justCopied = signal(false);

  async copyToClipboard(event: Event): Promise<void> {
    event.preventDefault();
    event.stopPropagation();
    const text = this.textToCopy();
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      this.justCopied.set(true);
      setTimeout(() => this.justCopied.set(false), 1500);
    } catch {
      /* clipboard not available */
    }
  }
}
